// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"6":"7ca6304624145a4e36cb","268":"dade0c08d84b72a30a42"}[chunkId] + ".css";
};